<template>
    <div class="tab-pane fade in active show" id="members" style="overflow-x: auto;">
        <loader-gif v-if="isRequestPayment" />
        <element-per-page />
        <img ref="refLogo" src="@/assets/img/logo-black.png" alt="store" style="display: none;">


        <table v-if="transactions && transactions?.length > 0" class="datatables table table-striped table-bordered  ">
            <thead class="thead-dark">
                <tr>
                    <th>
                        <span v-if="reference == 'encaissement'">
                            {{ i18n.t('tables.payment.reference_type_encaissement') }}
                        </span>
                        <span v-else>
                            {{ i18n.t('tables.payment.reference_type_decaissement') }}
                        </span>
                    </th>
                    <th v-if="!isMember">
                        <!-- {{ i18n.t('tables.members.name') }} -->
                        Détails de l'opération
                    </th>
                    <th>
                        Commercial
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.paymentDate') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.paymentMethod') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.chequeName') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.bankName') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.chequeNum') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.dueDate') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.amount_paid') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.payment.status') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.action') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(transaction, index) in transactions" value="member.id"
                    v-bind:key="`transaction-${transaction?.id}-${index}`">
                    <td>
                        {{ paymentTypePathLabels[transaction?.reference_type] ?? 'Inconnu' }}
                    </td>
                    <td v-if="!isMember">

                        <span v-if="transaction?.member">
                            <member-route v-if="hasPermission('fiche_member')" :memberUUID="transaction?.member?.uuid"
                                :matricule="transaction?.member?.name" />
                            <span v-else>
                                {{ isMember ? member?.matricule : transaction?.member?.matricule }}
                            </span>
                        </span>


                      <span v-html="transaction?.reference_detail?.name"></span> 
                    </td>

                    <td>
                        {{  transaction?.reference_detail?.sellerName ?? ''}}
                    </td>
                    <td>
                        {{ formatDate(transaction?.paymentDate) }}
                    </td>

                    <td>
                        {{ transaction.paymentMethod ?? '-' }}
                    </td>
                    <td>
                        {{ transaction.chequeName ?? '-' }}
                    </td>

                    <td>
                        {{ transaction?.bankName ?? '-' }}
                    </td>

                    <td>
                        {{ transaction?.chequeNum ?? '-' }}
                    </td> 
                    <td>

                      
                       <p v-if="transaction?.status == 'scheduled'">
                            <small>
                                <b> {{ i18n.t('tables.payment.accessBlockDate') }}</b>
                            </small>
                        </p>
                        {{ formatDate(transaction?.dueDate) ?? '-' }}
                    </td>
                    <td>
                        {{ transaction?.amount_paid ?? 0.00 }} {{ i18n.t('symbole.currency.mad')
                        }}
                    </td>
                    <td>

                        <element-status-payment :status="transaction?.status" />
                    </td>
                    <td>
                        <span v-if="transaction.reference_detail?.memberUUID && hasPermission('impayes') && transaction?.reference_type === PAYMENT_TYPE_PATH.SUBSCRIPTION">
                            <btn-default v-if="hasPermission('impayes')" :btnClass="`btn btn-show m-1`"
                                @default="redirectTo({ name: 'impayes', params: { subscriptionID: transaction.reference_detail?.id, clubUUID: clubUUID, memberUUID: transaction.reference_detail?.memberUUID } })"
                                icon="eye" :tooltip="i18n.t('button.details')" />
                        </span>

                        <span v-if="hasPermission('delete_transaction')">
                            <btn-delete v-if="transaction?.reference_type !== PAYMENT_TYPE_PATH.PRODUCT_SALE"
                                @delete="Delete(transaction?.id)" />
                            <span v-else>
                                Vous ne pouvez<br>pas le supprimer.
                            </span>
                        </span>
                    </td>
                </tr>

            </tbody>
        </table>
        <div v-else>
            <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType, ref } from "vue";

import Swal from "sweetalert2";
import i18n from "@/i18n/index"
/*Components*/

import type { Payment } from "@/interfaces/payment";
import type { Member } from "@/interfaces/member";

import { usePayment } from "@/composables/payment/usePayment";
import { usePermission } from "@/composables/auth/usePermission";
import { useGlobal } from "@/composables/global/useGlobal";
import { userPermissions, clubUUID, participations, currentClub } from "@/shared/state";
import { paymentTypePathLabels, PAYMENT_TYPE_PATH } from "@/shared/cashReport";
export default defineComponent({
    components: {
    },
    name: "subscriptions-list",
    emits: ['remove-transaction'],
    props: {
        transactions: {
            type: Array as PropType<Payment[] | null>,
            default: null,
        },
        member_UUID: {
            type: String,
            default: ''
        },
        invoice: {
            type: Boolean,
            default: false
        },
        isMember: {
            type: Boolean,
            default: false
        },
        member: {
            type: Object as PropType<Member | null>,
            default: null,
        },
        reference: {
            type: String,
            defautl: 'encaissement'
        }
    },
    setup(props, { emit }) {
        const {
            formatDate,
            redirectTo,
            //  printOrSaveToPdf
        } = useGlobal();
        // const {   exportPaymentReceipt } = useCreditPDF();

        const { hasPermission } = usePermission();

        const { deletePayment, isRequestPayment } = usePayment();
        const userPermissionsList = computed(() => userPermissions.data);
        const participationsList = computed(() => participations.data);


        const Delete = (paymentID: number) => {

            Swal.fire({
                title: i18n.t("message.confirmation.payment.delete.title"),
                text: i18n.t("message.confirmation.payment.delete.text"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: i18n.t("button.delete"),
                cancelButtonText: i18n.t("button.cancel"),
                allowOutsideClick: false, // ✅ disable closing by clicking outside
                allowEscapeKey: false, // (optional) disable closing with ESC
            }).then(async (result) => {
                if (result.isConfirmed) {
                    deletePayment(paymentID).then((res) => {


                        if (props?.transactions) {
                            emit('remove-transaction', paymentID);
                        }

                    })
                }
            });




        };

        return {
            // refLogo, 
            formatDate,
            redirectTo,
            clubUUID,
            i18n,
            hasPermission,
            Delete,
            participationsList,
            userPermissionsList,
            isRequestPayment,

            paymentTypePathLabels,
            PAYMENT_TYPE_PATH
        };
    },
});
</script>
